(function () {
  document.addEventListener('click', function (event) {
    try {
      if (!(event.target instanceof Element)) return;
      var cta = event.target.closest('[data-bundle-cplus-cta]');
      if (!cta || !window.posthog || typeof window.posthog.capture !== 'function') return;
      window.posthog.capture('bundle_cplus_cta_click', {
        source_product_handle: cta.dataset.sourceProductHandle || null,
        section_id: cta.dataset.sectionId || null,
        target: cta.dataset.target || null,
        variant_count: Number(cta.dataset.variantCount) || null,
        collection: cta.dataset.collection || null,
        instrumentation_source: cta.dataset.instrumentationSource || null
      }, { send_instantly: true });
    } catch (e) {
      console.warn('[PostHog] Bundle C+ CTA capture failed:', e);
    }
  });
})();
